import { CSSObject } from '@chakra-ui/react';
import mascot from '@/assets/titanbet/images/header/mascot.png';
import { CustomButtonProps } from '@/components/Button/Button';

export const BoxBallance: CSSObject = {
  bgGradient: 'linear(to-b, beta.600, beta.400)',
  borderX: '4px',
  borderColor: 'beta.200',
  '> div:first-of-type': {
    color: 'gamma.300',
    '> p': {
      fontSize: 'md',
      fontWeight: 'medium',
    },
    '> div': {
      '> p': {
        fontSize: 'md',
      },
    },
  },
  '> div:last-of-type': {
    color: 'white',
    '> p': {
      fontSize: 'md',
      fontWeight: 'medium',
    },
    '> div': {
      '> p': {
        fontSize: 'md',
      },
    },
  },
};

export const buttonDepositProps: CustomButtonProps = {
  variant: 'solid',
  fontWeight: 'normal',
  w: 'full',
  mt: '2',
  sx: {
    '& svg': {
      textShadow: '0px 1px 2px rgba(0, 0, 0, 0.40)',
      mb: '1',
    },
  },
};

export const ButtonNavItem = (): CSSObject => ({
  bg: 'beta.200',
  color: 'beta.100',
  borderTop: '1px',
  borderColor: 'beta.100',

  '&& > p': { transition: 'all 0.2s ease-in-out' },
  ':first-child': {
    borderTop: 'none',
  },
  '&:hover, &:active': {
    bg: 'beta.300',
  },
});

export const BoxMascotImage: CSSObject = {
  bgImage: `url(${mascot})`,
  bgSize: '50% auto',
  bgPos: 'inherit',
  bgRepeat: 'no-repeat',
  zIndex: '-1',
  display: ['none', null, null, null, 'block'],
  w: '40',
  h: '32',
  pos: 'absolute',
  top: '2.5',
  left: '2',
};

export const PopoverHeaderQA: CSSObject = {
  bg: 'beta.600',
  borderTop: '4px',
  borderX: '4px',
  borderColor: 'beta.200',
  borderBottom: 'none',
  borderTopRadius: 'base',
  pb: '0',
  color: 'white',
  lineHeight: 'normal',
};

export const PopoverContentQA: CSSObject = {
  boxShadow: '2xl',
  borderRadius: 'sm',
  top: -2,
  _focus: {
    boxShadow: '2xl',
  },
};

export const FlexBallanceItem: CSSObject = {
  color: 'white',

  p: {
    _last: { fontWeight: 'extrabold' },
  },
};

export const TextBalanceValue: CSSObject = {
  color: 'alpha.500',
  textShadow: '0px 2px 3px rgba(0, 0, 0, 0.2)',
  fontSize: 'sm',
  fontWeight: 'extrabold',
};

export const TextQuickAccessHello: CSSObject = {
  fontSize: 'sm',
};

export const buttonBalanceProps: CustomButtonProps = {
  variant: 'unstyled',
  display: 'flex',
  fontSize: 'sm',
  h: 'unset',
};
